<mat-dialog-content class="mat-typography">
    <div class="loading" *ngIf="loading">
        <mat-spinner diameter="20"></mat-spinner>
        Please wait...
    </div>
    <ng-container *ngIf="!loading">
        <image-cropper
            [aspectRatio]="aspectRatio"
            [maintainAspectRatio]="true"
            [imageURL]="data.image.secure_url"
            (imageCropped)="imageCropped($event)"
        ></image-cropper>
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button color="fiord" (click)="cancel()" *ngIf="!loading">Cancel</button>
    <div style="flex:1"></div>
    <button mat-button color="lightGreen" (click)="done()" *ngIf="!loading">Done</button>
</mat-dialog-actions>